<section id="secao-previa-incubadora">
  <div class="container py-5">
    <div class="row descricao">
      <div class="col-md-8">
        <div class="titulo">
          <h1 class="titulo">Incubadora de empresas</h1>
        </div>
        <div class="texto">
          <p>
            Pautada no estímulo ao empreendedorismo e inovação e reconhecida
            nacionalmente como um incubadora de empresas de base tecnológica, A
            Fundação Educere graduou desde a sua criação, 16 empresas nas áreas de
            saúde e estética/beleza, biotecnologia, agronegócio, educação e eletrônica.
          </p>
          <p>
            Nove empresas graduadas,juntamente com a empresa Cristófoli
            Biossegurança, são mantenedoras da instituição, cujos empresários
            integram a equipe de mentores dos empreendimentos incubados.
          </p>
        </div>
        <button
          routerLink="/empreendedorismo-inovacao"
          type="button"
          class="btn btn-primary"
        >
          Saiba mais
        </button>
      </div>
      <div class="col-md-4 icone">
        <img src="assets/imagens/lamp.png" class="lamp" alt="" />
      </div>
    </div>
  </div>
</section>
